import { createContext, useContext, useState, useEffect } from 'react'

export const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {} })
export function useTheme() { return useContext(ThemeContext) }

const THEMES = {
  dark: {
    '--bg':         '#0a0a0f',
    '--bg2':        '#111118',
    '--surface':    'rgba(255,255,255,0.03)',
    '--border':     'rgba(255,255,255,0.07)',
    '--text':       '#e8e8f0',
    '--text2':      '#9090b0',
    '--text3':      '#55556a',
    '--input-bg':   '#0d0d18',
    '--sidebar-bg': '#07070e',
    '--card-bg':    'rgba(255,255,255,0.03)',
  },
  light: {
    '--bg':         '#f2f2f7',
    '--bg2':        '#ffffff',
    '--surface':    '#ffffff',
    '--border':     'rgba(0,0,0,0.09)',
    '--text':       '#111118',
    '--text2':      '#444455',
    '--text3':      '#9999b0',
    '--input-bg':   '#f8f8fc',
    '--sidebar-bg': '#e8e8f0',
    '--card-bg':    '#ffffff',
  }
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark')

  useEffect(() => {
    const vars = THEMES[theme]
    Object.entries(vars).forEach(([k, v]) => document.documentElement.style.setProperty(k, v))
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme: () => setTheme(t => t === 'dark' ? 'light' : 'dark') }}>
      {children}
    </ThemeContext.Provider>
  )
}
